import React from 'react'
import Aux from '../../../hoc/Auxiliary'
import SectionHeading from '../../../components/Heading'

export const ContentBG = props => {
    return <Aux>
        <SectionHeading priority={1} text='Схеми на плащане' />

        <SectionHeading text='План 1 / Стандартен' />
        <ul>
            <li>2000 евро невъзвръщаем депозит при резервиране на вашия апартамент;</li>
            <li>30% от цената първа вноска, 14 календарни дни след резервацията, при подписване на предварителен договор (депозитът се приспада);</li>
            <li>30% от цената втора вноска, до 2 месеца от подписване на предварителният договор;</li>
            <li>30% от цената трета вноска, до 2 месеца след втора вноска;</li>
            <li>10% от цената четвърта вноска при акт 15;</li>
        </ul>

        <SectionHeading text='План 2 / 2% отстъпка от продажната цена' />
        <ul>
            <li>2000 евро невъзвръщаем депозит при резервиране на вашия апартамент;</li>
            <li>50% от цената първа вноска, 14 календарни дни след резервацията, при подписване на предварителен договор (депозитът се приспада);</li>
            <li>20% от цената втора вноска, до 2 месеца от подписване на предварителният договор;</li>
            <li>20% от цената трета вноска, до 2 месеца след втора вноска;</li>
            <li>10% от цената четвърта вноска при акт 15;</li>
        </ul>

        <SectionHeading text='План 3 / 5% отстъпка от продажната цена' />
        <ul>
            <li>2000 евро невъзвръщаем депозит при резервиране на вашия апартамент;</li>
            <li>90% от цената първа вноска, 14 календарни дни след резервацията, при подписване на предварителен договор (депозитът се приспада);</li>
            <li>10% от цената последна вноска при акт 15;</li>
        </ul>

        <SectionHeading text='План 4 с кредит' />
        <ul>
            <li>15-20% при подписване на предварителен договор;</li>
            <li>Останалите  вноските подлежат на договаряне!</li>
        </ul>

        <SectionHeading text='План 5 разсрочено плащане' />
        <ul>
            <li>15-20% при подписване на предварителен договор;</li>
        </ul>
        <p>Останалите вноски по споразумение.</p>

        <SectionHeading text='Цени' />
        <p>Цени на апартаменти с ДДС: от 777 евро/кв.м.<br />
            Цени на гаражи с ДДС: от 9 600 евро<br />
            Цени на магазини с ДДС: по договаряне</p>

        <SectionHeading text='Планиран срок на изпълнение' />
        <p>Акт 14 – не по-късно от 30.04.2019 г.<br />
            Акт 15 – не по-късно от 31.05.2020 г.</p>
    </Aux>
}

export default ContentBG



// WEBPACK FOOTER //
// ./src/routes/Payment/components/ContentBG.js